import { Slide } from "@jelly/lesson";
import config from "appConfig";

const principle: Slide = {
  title: "Introduction",
  layout: {
    type: "customCase050101",
    options: {
      text: `For this case study, typical room combinations found in schools were selected to explain what’s at stake in these environments. A school building is a good example because it contains a lot of situations typically found in several other types of buildings. Please click on the four cases and familiarize yourself with concepts from room acoustics and building acoustics. These cases are particularly useful for practicioners in the building industry. The cases allow one to start from the context/environment that they are used to and discover the problems and challenges through the ears of an acoustician.<br /><br />
      After having clicked on a case, the user will see a few numbers corresponding to positions on an isometric plan of a combination of different types of rooms. These numbers can be clicked to discover the challenges and problems for a particular combination of rooms or a specific detail. Then, a few relevant lessons are suggested to allow the user to dig deeper. `,
      images: [
        `${config.ASSETS_URL}/05/case-01/slide01-image01.svg`,
        `${config.ASSETS_URL}/05/case-01/slide01-image02.svg`,
        `${config.ASSETS_URL}/05/case-01/slide01-image03.svg`,
        `${config.ASSETS_URL}/05/case-01/slide01-image04.svg`,
      ],
      descriptions: [
        "Case 1:<br /><b>Library Stairwell Classroom Server room</b>",
        "Case 2:<br /><b>Music rooms Offices</b>",
        "Case 3:<br /><b>Playground Cafeteria Classrooms</b>",
        "Case 4:<br /><b>Gym hall Classroom Hallway Busy street</b>",
      ],
    },
  },
};

export default principle;
